module.exports = __webpack_public_path__ + "img/workforce-jornaleros.eb7c4582.webp";